import { useDealerDiscounts } from "app/hooks/checkout/useDealerDiscounts";
import { useDealerPriceInformations } from "app/hooks/checkout/useDealerPriceInformations";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { OptionTemplate } from "shared/api/middleware-api-client";

interface ZakelijkPriceDetailsProps {
  selectedDoor: OptionTemplate | null;
}

export const ZakelijkDiscountDetails: React.FC<ZakelijkPriceDetailsProps> = ({
  selectedDoor,
}) => {
  //Total price of product
  const totalPrice = selectedDoor?.price ?? 0;

  // Dealer discounts, loading
  const { businessDoorDiscount, isDealerDiscountsLoading } =
    useDealerDiscounts(totalPrice);

  // Calculated prices information
  const {
    totalZakelijkPrice,
    totalZakelijkPriceDiscounted,
    savedAmount,
    vatAmount,
  } = useDealerPriceInformations();

  if (!selectedDoor) return null;

  return (
    <>
      <div className="gg-flex gg-flex-col gg-space-y-1">
        <div className="gg-flex gg-flex-col">
          {/* Price formatted output */}
          <div className="gg-flex gg-items-center gg-gap-x-2">
            <h4 className="gg-self-center gg-text-xs gg-font-bold gg-text-gray-400 gg-line-through sm:gg-text-sm">
              {!isDealerDiscountsLoading ? (
                totalZakelijkPrice
              ) : (
                <Skeleton width={50} />
              )}
            </h4>
          </div>
          <h4 className="gg-text-base gg-font-bold gg-text-red sm:gg-text-lg">
            {!isDealerDiscountsLoading ? (
              totalZakelijkPriceDiscounted
            ) : (
              <Skeleton width={90} />
            )}
          </h4>
          <div className="gg-w-fit gg-bg-red gg-px-1">
            <h4 className="gg-py-0.5 gg-text-xs gg-font-bold gg-text-white">
              {!isDealerDiscountsLoading ? (
                <>
                  Korting €{savedAmount} ({businessDoorDiscount}%)
                </>
              ) : (
                <Skeleton width={145} />
              )}
            </h4>
          </div>
        </div>
        <div>
          <p className="gg-mt-1 gg-text-xs gg-text-purple-300">
            incl. €{vatAmount} btw
          </p>
        </div>
      </div>
    </>
  );
};
